export enum IndividualLeaderboardLogicEnum {
  AUDIENCE_BASED = 'AUDIENCE_BASED',
  LEADERBOARD_GROUP_BASED = 'LEADERBOARD_GROUP_BASED',
  DEFAULT = ''
}
